import memoizeOne from 'memoize-one';
import { useSelector } from 'react-redux';
import { specialtyTypesItemsSelector } from '../../../../selectors/specialtyTypes/specialtyTypesItemsSelector';
import { IApplicationState } from '../../../../types/redux';
import { TSpecialtyTypes } from '../../../../types/specialtyTypes';
import { DropdownOption, DropdownOptionsGroup, DropdownOptionsGroups } from '../../../FilterDropdown';

const getMemoizedDropdownOptionsGroups = memoizeOne(
  (specialtyTypes: TSpecialtyTypes['items']): DropdownOptionsGroups => {
    return new DropdownOptionsGroups<number>(
      [
        new DropdownOptionsGroup(
          'main',
          specialtyTypes.map(specialtyType => {
            return new DropdownOption(specialtyType.id, specialtyType.name);
          }),
        ),
      ],
      'Назначение',
    );
  },
);

export function useSpecialtyTypesItemsSelector(): DropdownOptionsGroups {
  const specialtyTypes = useSelector<IApplicationState, TSpecialtyTypes['items']>(specialtyTypesItemsSelector);

  return getMemoizedDropdownOptionsGroups(specialtyTypes);
}
